import React from 'react'

const Membershipsignup = process.env.REACT_APP_LINK_SIGNUP

const ModalPop = () => {
    return (
          <div className="accent-custom">
            <div className="modal fade" id="modal_signup" tabIndex={-1} aria-labelledby="modal_signupLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content cashback_modal_content">
                        <div className="modal-header brdr_btm0">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark" /></button>
                        </div>
                        <div className="modal-body">
                            <div className="modalcontainer">
                                <h2 className="f_mextrabold f_white f_sz60 text-center w-100">Get up to 12%<br />Cash Back</h2>
                                <div className="cashback_img text-center w-100 mt-15"><img src="assets/img/cashback/cashback1.png" border={0} /></div>
                            </div>
                        </div>
                        <div className="modal-footer brdr_top0">
                            <div className="d-flex w-100 justify-content-center mt-10 mb-10">
                                <a href={`${Membershipsignup}/signup`} className="tp-btn-blue1 tp_lrgebtn_pdng1 f_sz16 f_msemibold">Sign up for FREE</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ModalPop